const { pick } = require("lodash");

window.__mt.fn.onEditReservation = function onEditReservation(
  vm,
  $scope,
  $http,
  $timeout,
  $q,
  getReservations,
  $location
) {
  var _id = "";
  let textChange = "";
  let savedPassager = false;
  let savedRoute = false;
  let getAllAvailableCars = false;
  let delimiter = window.__mt.setting.delimiter;
  let comments = "";
  let last_comment = "";

  const EXTRA_DISCLAIMERS = {
      58: window.__mt.ln.extra_disclaimer_booster_seat,
      2532588: window.__mt.ln.extra_disclaimer_booster_seat,
      2533401: window.__mt.ln.extra_disclaimer_booster_seat,
      731: window.__mt.ln.extra_disclaimer_child_seat,
      46278: window.__mt.ln.extra_disclaimer_child_seat,
  };

  /****
   *    Start Code
   *    It's code to cancelled or update reservation, copy and paste in other page if you need these module.
   ****/
  var _reservation = {};
  var _booking = {};
  var format = "YYYY-MM-DD HH:mm";
  var currencyDefault = "EUR";

  var toggle = false;
  var hasChange = "";
  var phone_number = "";
  var iti_r;
  var origin, destination, _distance;
  var current_date = new Date();
  var base_price_provider = 0;
  current_date.setDate(current_date.getDate() + 1);
  vm._show = {
    load: "one",
  };
  vm.comment = "";
  vm.data = {};
  vm.old_data = {};
  vm.pickup_departure = true;
  vm.calendar = {
    oneway: true,
  };
  vm.isEdit = false;
  vm.showClientInformation = false;
  vm.editingSection = null; // Puede ser: null, 'route', 'vehicle', 'client', 'extras'
  vm.showVehicleOptions = false; // Variable para controlar la vista de selección de vehículos
  vm.distance = {};
  vm.exchange_convertion = window.__mt.setting.exchange.convertion;
  vm.cancellationHasInsurance = false;
  vm.cancellationCanBeRefunded = false;
  vm.cancelRefundEligible = null;
  vm.dateChangeError = false; // Para mostrar alerta cuando cambia fecha y no hay disponibilidad
  vm._backup_date = null; // Para guardar la fecha original antes de cambiarla
  vm.loadingRoute = false; // Loading específico para la card de ruta

  // Initialize edit mode from URL parameters
  function initFromUrl() {
    var urlParams = $location.search();
    if (urlParams.edit) {
      vm.isEdit = true;
      vm.edit(urlParams.edit, urlParams.email);
    }
  }

  // Call initialization on load
  $timeout(function() {
    initFromUrl();
  }, 100);

  vm.toggleEdit = function(id, email) {
    vm.isEdit = !vm.isEdit;
    if (vm.isEdit) {
      // Update URL with edit parameter
      $location.search('edit', id);
      if (email) {
        $location.search('email', email);
      }
      vm.edit(id, email);
    } else {
      // Clear URL parameters when exiting edit mode
      $location.search('edit', null);
      $location.search('email', null);
    }
  };

  vm.canEdit = function(editable) {
    return editable && !window.__mt.setting.disable_booking_modification;
  };

  function hasInsuranceProtection(reservation) {
    return Boolean(
      reservation &&
        (reservation.insurance === true ||
          reservation.insurance === 1 ||
          reservation.insurance === "1" ||
          reservation.has_insurance === true)
    );
  }

  function getCancellationPickupDate(reservation) {
    var pickup =
      reservation &&
      (reservation.pickUpDate ||
        reservation.pickup_datetime ||
        reservation.pickup_date ||
        (reservation.trip && reservation.trip.pickUpDate));

    if (!pickup) {
      return null;
    }

    var pickupDate = window.__mt.fn.getDate(pickup);

    if (!pickupDate || Number.isNaN(pickupDate.getTime())) {
      return null;
    }

    return pickupDate;
  }

  function canCancelBeforePickup(reservation) {
    var pickupDate = getCancellationPickupDate(reservation);
    return Boolean(pickupDate && new Date().getTime() < pickupDate.getTime() - 2 * 60 * 60 * 1000);
  }

  function isRefundEligibleForCancellation(reservation) {
    var pickupDate = getCancellationPickupDate(reservation);
    if (!pickupDate) {
      return false;
    }

    var maxHours = hasInsuranceProtection(reservation) ? 2 : 24;
    return new Date().getTime() < pickupDate.getTime() - maxHours * 60 * 60 * 1000;
  }

  function getInvoiceStatus(reservation) {
    var status = reservation && (
      reservation.invoiceStatus ||
      reservation.invoice_status ||
      reservation.status
    );

    return typeof status === "string" ? status.trim().toLowerCase() : "";
  }

  function isCancelledReservation(reservation) {
    var status = getInvoiceStatus(reservation);
    return status === "cancelled" || status === "refunded" || status === "cancel";
  }

  function isSuccessfulCancellationRefundable(response) {
    if (typeof response.could_refund !== "undefined") {
      return Boolean(response.could_refund);
    }

    return response.refund_status !== "not_refundable" && response.refund_status !== "none";
  }

  vm.canCancelBooking = function(reservation) {
    if (!reservation) {
      return false;
    }

    if (isCancelledReservation(reservation)) {
      return false;
    }

    return canCancelBeforePickup(reservation);
  };

 vm.getExtraImage = function(extra) {
        var imageMap = {
            731: '46278',
            46278: '46278',
            2532588: '2532588',
            58: '2532588'
        };

        var mappedId = imageMap[extra.extraId];
        if (mappedId) {
            return '/images/extras/' + mappedId + '.png';
        }

        return '/images/extras/no-found.png';
    }

    vm.getExtraDescription = function(extra) {
        var lang = window.__mt.ln;
        var descMap = {
            731: lang.extra_desc_booster_seat,
            46278: lang.extra_desc_booster_seat,
            2532588: lang.extra_desc_child_seat,
            58: lang.extra_desc_child_seat
        };

        return descMap[extra.extraId] || '';
    }

    vm.getExtraPriceWithComission = function(extraPrice) {
        return extraPrice > 0 ? (extraPrice + extra_comission) : extraPrice;
    }


  // Function to go back to reservations list
  vm.goBackToList = function() {
    vm.isEdit = false;
    // Clear URL parameters
    $location.search('edit', null);
    $location.search('email', null);
    // Reset editing states
    vm.editingSection = null;
    vm.showClientInformation = false;
    vm.showVehicleOptions = false;
  };

  // Función para controlar qué sección está en modo edición
  vm.setEditingSection = function(section) {
    // Si se hace clic en la misma sección, la cerramos
    if (vm.editingSection === section) {
      vm.editingSection = null;
      vm.showClientInformation = false;
      vm.submit = false; // Resetear el estado de submit al cerrar
      vm.submitSection = false; // Resetear validación de sección
    } else {
      // Cerrar todas las secciones
      vm.editingSection = section;
      vm.showClientInformation = section === "client";
      vm.submit = false; // Resetear el estado de submit al cambiar de sección
      vm.submitSection = false; // Resetear validación de sección

      // Guardar una copia de los datos actuales para poder cancelar cambios
      // Guardamos solo si no existe tempData (primera vez que abrimos esta sección)
      if (!vm.tempData) {
        vm.tempData = JSON.parse(JSON.stringify(vm.data));
      }

      // Si se abre la sección de cliente, re-inicializar el plugin de teléfono
      if (section === "client") {
        $timeout(() => {
          initPhoneReservation(vm.data.customerCountry);
        }, 300);
      }

      // Si se abre la sección de ruta, re-inicializar todo el estado
      if (section === "route") {
        // Resetear estado de errores y validación
        vm.valid_confirm = false;
        vm.routeChangeError = false;
        vm.routeChangeErrorType = null;
        vm.dateChangeError = false;
        vm.loadingRoute = false;
        vm.pickup_departure = true;
        vm._backup_search = null;
        vm._backup_date = null;
        savedRoute = false;

        // Restaurar valores de búsqueda desde los datos actuales del trip
        vm._search_confirm.from_view = vm.data.trip.pickup;
        vm._search_confirm.from = vm.data.trip.pickup;
        vm._search_confirm.to_view = vm.data.trip.dropoff;
        vm._search_confirm.to = vm.data.trip.dropoff;
        vm._search_confirm.search_from = {
          id: 1,
          lat: vm.data.trip.pickUpLat,
          lng: vm.data.trip.pickUpLng
        };
        vm._search_confirm.search_to = {
          id: 1,
          lat: vm.data.trip.dropoffLat,
          lng: vm.data.trip.dropoffLng
        };

        $timeout(() => {
          if (vm.distance && vm.distance.duration) {
            initPickers();
          }
        }, 300);
      }
    }
  };

  // Función para guardar cambios y cerrar la sección (para botón "Save changes")
  vm.closeEditingSection = function() {
    // Validar formulario antes de cerrar la sección
    vm.submitSection = true;

    // Verificar si el formulario es válido
    if (!vm.form || !vm.form.$valid) {
      // Si hay errores, no cerramos la sección
      // console.log('Validation errors in section, not closing');
      return;
    }

    // Si todo es válido, cerramos la sección
    vm.editingSection = null;
    vm.showClientInformation = false;
    vm.submitSection = false;
    vm.tempData = null; // Limpiar datos temporales
  };

  // Función para guardar sección y abrir modal de confirmación directamente
  vm.saveSection = function(closeFn) {
    if (closeFn) closeFn();
    // Si la sección no cerró (validación falló, o se abrió vista de vehículos), no abrir modal
    if (vm.editingSection !== null || vm.showVehicleOptions) return;
    vm.save();
  };

  // Función para cancelar cambios y cerrar la sección (para botón "Cancel")
  vm.cancelEditingSection = function() {
    var wasRouteSection = vm.editingSection === 'route';

    // Si estamos cancelando desde la sección de vehículos después de un cambio de ruta,
    // restaurar los valores de la ruta original
    if (vm.editingSection === 'vehicle' && vm._backup_search) {
      vm.resetRouteChanges();
    }

    // Restaurar los datos desde la copia temporal
    if (vm.tempData) {
      vm.data = JSON.parse(JSON.stringify(vm.tempData));
      vm.tempData = null;
    }
    vm.editingSection = null;
    vm.showClientInformation = false;
    vm.submit = false;
    vm.submitSection = false; // Resetear validación de sección

    // Resetear estado de validación de fechas y backup
    if (wasRouteSection) {
      vm.pickup_departure = true;
      vm._backup_date = null;
      vm.dateChangeError = false;
      vm.loadingRoute = false;
    }
  };

  vm.timeoutStop = function() {
    window.__mt.setting.idleStop();
  };

  vm.limitTimeToEdit = function(date) {
    var today = new Date();
    var pickup = window.__mt.fn.getDate(date);

    today = today.setDate(today.getDate() + window.__mt.setting.minimum_time);

    return today < pickup;
  };

  vm.isDatePassed = function(date) {
    if (!date) return false;
    var now = new Date();
    var d = window.__mt.fn.getDate(date);
    return d < now;
  };

  vm.hasExtrasWithAmount = function() {
    if (!vm.data.extras || !vm.data.extras.length) return false;
    return vm.data.extras.some(function(extra) {
      return extra.amount > 0;
    });
  };

  function vehicleHasBookedExtras(option) {
    if (!vm.data.extras || !vm.data.extras.length) return true;

    var bookedExtras = vm.data.extras.filter(function(e) { return e.amount > 0; });
    if (!bookedExtras.length) return true;

    var optionExtraIds = (option.extras || [])
      .filter(function(e) { return e.maxUnits > 0; })
      .map(function(e) { return String(e.extraId); });

    return bookedExtras.every(function(booked) {
      return optionExtraIds.indexOf(String(booked.extraId)) !== -1;
    });
  }

  vm.edit = function(id, email) {
    getBooking(id, email);
  };

  vm.cancel = function(reservation) {
    vm._show.load = "one";
    vm.comment = "";
    vm.cancelRefundEligible = null;
    //_reservation = reservation;
    _id = reservation.booking_id || reservation.Id || reservation;
    var params = {
      id: reservation.booking_id || reservation.Id || reservation,
      email: reservation.email || vm.prof.customerEmail,
    };

    vm.loading = true;
    $http
      .post(window.__mt.setting.api_booking, params)
      .then(getCancelBookingSuccess, getBookingError);
  };

  vm.onCancel = function() {
    vm.cancellingBooking = true;
    vm.cancelSuccess = false;
    vm.cancelError = false;
    vm.cancelTimeError = false;
    vm.cancelRefundEligible = null;
    var params = {
      id: _reservation.bookingReference,
      editable: _reservation.editable,
      pickup: _reservation.pickUpDate,
      lang: window.__mt.ln.lang,
      comment: vm.comment,
    };
    $http
      .post(window.__mt.setting.api_cancel, params)
      .then(onCancelSuccess, onCancelError);
  };

  vm.onCloseCancel = function() {
    vm.cancellingBooking = false;
    vm.cancelSuccess = false;
    vm.cancelError = false;
    vm.cancelTimeError = false;
    vm.cancelRefundEligible = null;
    vm.cancellationHasInsurance =
      hasInsuranceProtection(vm.data) || hasInsuranceProtection(_reservation);
    vm.cancellationCanBeRefunded = isRefundEligibleForCancellation(_reservation);
    $("#cancelBookingModal").modal("hide");
    if (vm._cancelledOk) {
      vm._cancelledOk = false;
      vm.isEdit = false;
    }
  };

  vm.changeCalendar = function(id, cal, type = null) {
    vm.calendar[id] = false;

    $timeout(() => {
      vm.openCalendar(cal, type);
    }, 100);
  };

  vm.openCalendar = function(id, type = null) {
    //showAlert(vm.data.trip,false);// rountrip =  false
    //if (!vm.calendar.oneway) {
    vm.msn.selected = type;
    $timeout(() => {
      $("#" + id)
        .data("daterangepicker")
        .toggle();
    }, 100);
    //}
  };

  vm.recommendedTime = function(date, time_google, time, type) {
    var current = window.__mt.fn.getDate(date);
    var delay = getTimeDelay(time, type);
    var sum_time = time_google / 60 + delay;
    current.setMinutes(current.getMinutes() - sum_time);

    return current;
  };

  let flip = 0;
  vm.showPassenger = function() {
    toggle = !toggle;
    $("#pax-view-pro").toggle(flip++ % 2 === 0);
    /**if (!toggle) {
            requote();
        }**/
  };
  let changedPersons = false;
  vm.savePassager = function() {
    vm.data.savePassager = false;
    changedPersons = true;
    savedPassager = true;
    requote();
    vm.showChangePassagers = false;
  };

  vm.handlePassengerSave = function() {
    if (vm.car && vm.car.maxPassengers && vm.totalPassages > vm.car.maxPassengers) {
      vm.closeEditingSection();
      vm.listCars();
    } else {
      vm.savePassager();
      vm.closeEditingSection();
    }
  };

  function defaultPassagers() {
    vm.data.children = vm.old_data.children;
    vm.data.adults = vm.old_data.adults;
    vm.data.infants = vm.old_data.infants;
    vm._search_confirm.adults = vm.old_data.adults;
    vm._search_confirm.infants = vm.old_data.infants;
    vm._search_confirm.children = vm.old_data.children;
    $timeout(function() {
      $scope.$apply();
    });
  }
  function validPassagers() {
    let valid = false;
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
    let old_total =
      Number.parseInt(vm.old_data.children) +
      Number.parseInt(vm.old_data.adults) +
      Number.parseInt(vm.old_data.infants);
    if (
      vm.data.children != vm.old_data.children ||
      vm.data.adults != vm.old_data.adults ||
      vm.data.infants != vm.old_data.infants
    ) {
      valid = true;
    }

    return valid;
  }
  /** Action hiden checkbox  passagers**/
  $(document).mouseup(function(e) {
    var container = $("#pax-view-pro");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.hide();
      flip = 0;
    }
  });

  vm.addPax = function(pax) {
    vm._search_confirm[pax] += 1;
    vm.data[pax] += 1;
    savedPassager = false;
    vm.showChangePassagers = validPassagers();

    // Calcular total de pasajeros
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
  };

  vm.removePax = function(pax, min) {
    if (vm._search_confirm[pax] - 1 >= min) {
      vm._search_confirm[pax] -= 1;
      vm.data[pax] -= 1;
    }
    savedPassager = false;
    vm.showChangePassagers = validPassagers();

    // Recalcular total de pasajeros
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
  };

  vm.hasChangeField = function(_old, _new, key = null) {
    if (vm.form && vm.form.$valid && vm.submit && _old != _new) {
      writeTextChanges(key, _old, _new);
    }
    return _old == _new;
  };

  vm.goBack = function() {
    // $(".ca-container").hide();
    // $("#id-reservation").show();
  };

  function hasChanges() {
    var d = JSON.parse(JSON.stringify(vm.data));
    var oldData = JSON.parse(hasChange);

    // Normalizar teléfonos para comparación consistente
    if (d.customerPhone) {
      d.customerPhone = d.customerPhone.replace(/\s/g, "");
    }
    if (oldData.customerPhone) {
      oldData.customerPhone = oldData.customerPhone.replace(/\s/g, "");
    }

    var _hasChange = JSON.stringify(d);
    var _oldChange = JSON.stringify(oldData);

    // console.log('hasChanges - Checking...');
    // console.log('Current data:', _hasChange);
    // console.log('Original data:', _oldChange);
    // console.log('Data changed:', _hasChange != _oldChange);
    // console.log('Car changed:', hasChangeCar());

    return _hasChange != _oldChange || hasChangeCar();
  }
  function hasChangeCar() {
    // Verificar si vm.qt existe y tiene selected
    if (vm.qt && vm.qt.selected) {
      let _old = JSON.stringify(vm.data.car);
      let _new = JSON.stringify(vm.car);
      return _old != _new;
    }
    return false;
  }

  function hasRouteOrTimeChanges() {
    if (!vm.old_data || !vm.old_data.trip || !vm.data || !vm.data.trip) {
      return false;
    }

    return (
      vm.old_data.trip.pickup != vm.data.trip.pickup ||
      vm.old_data.trip.dropoff != vm.data.trip.dropoff ||
      vm.old_data.trip.pickUpDate != vm.data.trip.pickUpDate ||
      vm.old_data.trip.departureTransportDate != vm.data.trip.departureTransportDate ||
      vm.old_data.trip.arrivalTransportLine != vm.data.trip.arrivalTransportLine ||
      vm.old_data.trip.arrivalTransportLocator != vm.data.trip.arrivalTransportLocator ||
      vm.old_data.trip.departureTransportLine != vm.data.trip.departureTransportLine ||
      vm.old_data.trip.departureTransportLocator != vm.data.trip.departureTransportLocator
    );
  }

  vm.getPaidChangeReason = function() {
    if (!(vm.qt && vm.qt.transport && vm.showPrice(vm.qt.transport) > 0)) {
      return "";
    }

    if (hasChangeCar()) {
      return "vehicle";
    }

    if (hasRouteOrTimeChanges()) {
      return "route";
    }

    return "generic";
  };

  function writeTextChanges(key, oldText, newTxt) {
    // Convertir a string para evitar errores si es null, undefined, número, etc.
    let newText = String(newTxt || '').replace(/\r?\n|\r/g, " ");
    let oldTextStr = String(oldText || '');
    let text = `<b>${key}</b> : <del>${oldTextStr}</del> > ${newText}<br/>`;
    let arrText = textChange.split("\n");
    let repeat = false;

    for (let index = 0; index < arrText.length; index++) {
      const element = arrText[index];
      if (element == text) {
        repeat = true;
        break;
      }
    }

    if (!repeat) {
      textChange += `<b>${key}</b> : <del>${oldTextStr}</del> > ${newText}<br/>\n`;
    }
  }

  function getBooking(id, email) {
    var user = __mt.setting.user || {};
    _id = id;

    var params = {
      id: id,
      user_id: user.id,
      user_type: user.type,
    };

    // En contexto sin sesión (detail page) se pasa el email para que
    // la API pueda localizar la reserva sin autenticación.
    if (email) {
      params.email = email;
    }

    vm.loading = true;
    $http
      .post(window.__mt.setting.api_booking, params)
      .then(getBookingSuccess, getBookingError);
  }

  function getBookingSuccess(data) {
    var response = data.data;
    if (response.status == 200 && response.booking) {
      reset();
      _booking = response.booking;
      vm.loading = false;
      initEdit();
      //$("#c-modal-edit").modal("show");
      //$(".ca-container").hide();
      initModal();
    } else {
      getBookingError(data);
    }
  }

  function initModal() {
    if (iti_r) {
      iti_r.destroy();
    }
    $("#id-modify-booking").show();
    $("#edit-modal").modal("show");
    $("#nav-home-tab").tab("show");

    $("#c-edit-route-info-1, #c-btn-change").addClass("d-none");
    $("#c-edit-route-info-2, #c-btn-change").addClass("d-none");
    $("#c-btns-footer, #c-default-route-information").removeClass("d-none");
    window.__mt.setting.idleStart();
  }

  function getCancelBookingSuccess(data) {
    var response = data.data;
    if (response.status == 200) {
      _reservation = window.__mt.fn.findObject(
        response.booking.bookedDetails,
        "bookingReference",
        _id
      );
      vm.cancellationHasInsurance =
        hasInsuranceProtection(_reservation) || hasInsuranceProtection(response.booking);
      _reservation.has_insurance = vm.cancellationHasInsurance;
      vm.cancellationCanBeRefunded = isRefundEligibleForCancellation(_reservation);
      vm.editableCancel = vm.canCancelBooking(_reservation);
      vm.loading = false;
      $("#cancelBookingModal").modal("show");
    } else {
      getBookingError(data);
    }
  }

  function getBookingError(data) {
    vm.loading = false;
    vm.isEdit = false; // Volver a la lista de reservas
    $("#c-modal-feedback").modal("show");
  }

  function onCancelSuccess(data) {
    var res = data.data;
    vm.cancellingBooking = false;
    if (res.code == 200) {
      vm.cancelRefundEligible = isSuccessfulCancellationRefundable(res);
      vm.cancelSuccess = true;
      vm._cancelledOk = true;
      getReservations();
    } else if (res.code == 404) {
      vm.cancelTimeError = true;
    } else {
      onCancelError(data);
    }
  }

  function onCancelError(data) {
    vm.cancellingBooking = false;
    vm.cancelError = true;
    // console.log(data);
  }

  function initEdit() {
    $("#pax-view-pro").hide();
    var detail = window.__mt.fn.findObject(_booking.bookedDetails, "bookingReference", _id)
                 || _booking.bookedDetails[0];
    textChange = "";
    vm.submit = false;
    vm.data = {};
    vm.data.trip = {};
    vm.data.price = {};

    var pickupDate = detail.pickUpDate;
    var externalDate = detail.departureTransportDate;
    var transportDate = detail.arrivalTransportDate;

    if (externalDate) {
      externalDate = externalDate.replace(":00.0", "");
    }

    if (pickupDate) {
      pickupDate = pickupDate.replace(":00.0", "");
    }

    if (transportDate) {
      transportDate = transportDate.replace(":00.0", "");
    }

 

    vm.data.customerEmail = _booking.customerEmail;
    vm.data.confirm_email = _booking.customerEmail;
    vm.data.customerFirstName = _booking.customerFirstName;
    vm.data.customerLastName = _booking.customerLastName;
    vm.data.specialRequirements = getLastComment(_booking.specialRequirements);
    vm.data.adults = _booking.adults;
    vm.data.infants = _booking.infants;
    vm.data.children = _booking.childs;
    vm.data.customerCountry = _booking.customerCountry;
    vm.data.editable = detail.editable;
    vm.data.bookingType = _booking.bookingType || '';
    vm.data.insurance = detail.insurance || _booking.insurance || false;
    vm.data.has_insurance = hasInsuranceProtection(detail) || hasInsuranceProtection(_booking);
    vm.data.customerPhone = _booking.customerPhone
      .replace(/\(.*\)\s/g, "")
      .replace(/\s/g, "");

    vm.data.trip.bookingReference = detail.bookingReference;
    vm.data.trip.dropoff = detail.dropoff.replace(/\([\w\d\s]{5,}\)/g, "");
    vm.data.trip.dropoffType = detail.dropoffType;
    vm.data.trip.departureTransportDate = externalDate;
    vm.data.trip.departureTransportLine = detail.departureTransportLine;
    vm.data.trip.departureTransportLocator = detail.departureTransportLocator;

    vm.data.trip.pickup = detail.pickup.replace(/\([\w\d\s]{5,}\)/g, "");
    vm.data.trip.arrivalTransportDate = transportDate;
    vm.data.trip.arrivalTransportLine = detail.arrivalTransportLine;
    vm.data.trip.arrivalTransportLocator = detail.arrivalTransportLocator;
    vm.data.trip.pickupType = detail.pickupType;
    vm.data.trip.pickUpDate = pickupDate;
    vm.data.trip.hours = detail.hours || 0;
    vm.data.trip.pickUpLat = detail.pickUpLat;
    vm.data.trip.pickUpLng = detail.pickUpLng;
    vm.data.trip.dropoffLat = detail.dropoffLat;
    vm.data.trip.dropoffLng = detail.dropoffLng;
    vm.cancellationHasInsurance = hasInsuranceProtection(vm.data) || hasInsuranceProtection(detail);
    vm.data.price.totalPrice =
      detail.totalPrice ||
      _booking.totalPrice.transfersPrice ||
      _booking.totalPrice.totalPrice;
    vm.data.price.currency = _booking.totalPrice.currency || currencyDefault;



    var transfer = detail.bookedTransfer || _booking.bookedTransfer;

    vm.data.bookingReference = detail.bookingReference;
    vm.data.Id = detail.bookingReference;
    vm.data.booking_id = detail.bookingReference;
    vm.data.email = _booking.customerEmail;

    vm.data.transport_id = transfer.transportId;
    vm.data.provider_id = detail.providerId;
    vm.data.provider_price_id = detail.providerPriceId;
    vm.data.hasMeet = _booking.hasMeet;
    vm.data.meetAndGreet = _booking.meetAndGreet;
    //vm.data.type_reservation = detail.bookingExternalReference;
    vm.data.type_reservation = _booking.roundTrip;
    vm.data.status = (detail.invoiceStatus || detail.status || "").toLowerCase();
    vm.data.isDisBooking = vm.data.bookingType === 'DisBooking';
    vm.data.car = {};
    vm.data.car.transportId = transfer.transportId;
    vm.data.car.imageURL = transfer.imageURL;
    vm.data.car.maxPassengers = transfer.maxPassengers;
    vm.data.car.minPassengers = transfer.minPassengers;
    vm.data.car.price = transfer.price;
    vm.data.car.suitcases = transfer.suitcases;
    vm.data.car.transportName = transfer.transportName;

    /** Datos del driver **/
    if (_booking.driverInfo) {
      vm.data.driverInfo = _booking.driverInfo;
    }
    /** end datos del driver **/

    /** Datos de extras **/
    if (detail.extras && detail.extras.length) {
      vm.data.extras = detail.extras;
      vm.data.extras.forEach(function(extra) {
        if (EXTRA_DISCLAIMERS[extra.extraId]) {
          extra.extraName = extra.extraName.replace(/\s*\(.*?\)\s*$/, '')
            + ' ' + EXTRA_DISCLAIMERS[extra.extraId];
        }
      });
    }
    /** end datos de extras **/

    vm._search_confirm.adults = _booking.adults;
    vm._search_confirm.infants = _booking.infants;
    vm._search_confirm.children = _booking.childs;

    vm._search_confirm.search_from.id = 1;
    vm._search_confirm.search_to.id = 1;

    vm._search_confirm.search_from.lat = detail.pickUpLat;
    vm._search_confirm.search_from.lng = detail.pickUpLng;
    vm._search_confirm.search_to.lat = detail.dropoffLat;
    vm._search_confirm.search_to.lng = detail.dropoffLng;

    // Inicializar los valores de vista para los inputs de address
    vm._search_confirm.from_view = vm.data.trip.pickup;
    vm._search_confirm.to_view = vm.data.trip.dropoff;
    vm._search_confirm.from = vm.data.trip.pickup;
    vm._search_confirm.to = vm.data.trip.dropoff;
    /** Datos del cliente **/
    vm.data.client_key = _booking.clientKey;
    vm.data.client_id = _booking.clientId;
    $timeout(() => {
      initPhoneReservation(vm.data.customerCountry);
    }, 300);
    labelTrip();
    getDistance();
    showAlertInit();

    hasChange = JSON.stringify(vm.data);
    vm.old_data = JSON.parse(hasChange);

    // Guardar también las coordenadas de _search_confirm para poder restaurarlas después del reset
    vm.old_data._search_confirm = {
      search_from: angular.copy(vm._search_confirm.search_from),
      search_to: angular.copy(vm._search_confirm.search_to),
      adults: vm._search_confirm.adults,
      children: vm._search_confirm.children,
      infants: vm._search_confirm.infants
    };

    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);
    vm.typePickup = vm.data.trip.pickupType;
    vm.typeDropoff = vm.data.trip.dropoffType;
    vm.car = vm.data.car;
    base_price_provider = detail.providerTotalPrice;
    
  }

  function initPhoneReservation(country) {
    var input = document.querySelector("#phone_r");

    if (!input) {
      // console.log('initPhoneReservation: input #phone_r not found');
      return;
    }

    // console.log('initPhoneReservation: initializing with country', country);

    // Destruir la instancia anterior si existe
    if (iti_r) {
      iti_r.destroy();
      iti_r = null;
    }

    iti_r = window.intlTelInput(input, {
      utilsScript: window.__mt.setting.utils_script_url,
      initialCountry: "auto",
      separateDialCode: true,
      initialCountry: country || "auto",
      localizedCountries: window.__mt.setting.format_codes,
      preferredCountries: window.__mt.setting.preferred_countries,
      /*geoIpLookup: function (success, failure) {
                success(countryCode);
            },*/
    });

    input.addEventListener("blur", function() {
      if (input.value.trim()) {
        var vali = true;
        if (!iti_r.isValidNumber()) {
          vali = false;
        }
      }
    });

    input.addEventListener("countrychange", function() {
      var country = iti_r.getSelectedCountryData();
      if (country && country.dialCode) {
        //$("#country").val(country.iso2.toUpperCase());
        phone_number = country.dialCode;
        $scope.$apply(() => {
          vm.data.customerCountry = country.iso2.toUpperCase();
        });
      }
    });
  }

  function labelTrip() {
    var lang = window.__mt.ln;
    switch (vm.data.trip.pickupType) {
      case "airport":
        vm.ln.type_pickup = lang.pickup_date_flight;
        vm.ln.type_pickup_en = "Flight arrival date & time";
        break;
      case "train_station":
        vm.ln.type_pickup = lang.pickup_date_train;
        vm.ln.type_pickup_en = "Train arrival date & time";
        break;
      case "port":
        vm.ln.type_pickup = lang.pickup_date_port;
        vm.ln.type_pickup_en = "Disembarkation date & time";
        break;
      default:
        vm.ln.type_pickup = lang.pickup_date_address;
        vm.ln.type_pickup_en = "Pickup date & time";
        break;
    }

    switch (vm.data.trip.dropoffType) {
      case "airport":
        vm.ln.type_dropoff = lang.dropoff_date_flight;
        vm.ln.type_dropoff_en = "Flight arrival date & time";
        break;
      case "train_station":
        vm.ln.type_dropoff = lang.dropoff_date_train;
        vm.ln.type_dropoff_en = "Train arrival date & time";
        break;
      case "port":
        vm.ln.type_dropoff = lang.dropoff_date_port;
        vm.ln.type_dropoff_en = "Disembarkation date & time";
        break;
      default:
        vm.ln.type_dropoff = lang.dropoff_date_address;
        vm.ln.type_dropoff_en = "Pickup date & time";
        break;
    }
  }

  function initPickers() {
    var minDate = window.__mt.fn.getDate(vm.data.trip.pickUpDate);
    minDate.setDate(minDate.getDate() - 1);
    var today = window.__mt.fn.getDate();
    //var arrival_original = vm.data.trip.pickUpDate;
    var dropoffdate = vm.data.trip.departureTransportDate;

    /*if (vm.data.trip.pickup == "address" && vm.data.trip.dropoff != "address") {
            var datepicker_init = vm.data.trip.pickUpDate;
            var date_init = vm.recommendedTime(datepicker_init, 0, 0, vm.data.trip.dropoffType);
            vm.data.trip.pickUpDate = window.__mt.fn.formatDate(date_init, 'yyyy-MM-dd HH:mm');
        }*/

    //recotizeReturn(vm.checkout.quote.departure_date,  vm.data.trip.pickUpDate);

    var arrival_date = window.__mt.fn.getDate(vm.data.trip.pickUpDate);

    $("#arrival_date").daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      startDate: arrival_date,
      minDate: today,
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 5,
      drops: "up",
      locale: {
        format: format,
        daysOfWeek: window.__mt.setting.format.daysOfWeek,
        monthNames: window.__mt.setting.format.monthNames,
        firstDay: 0,
        applyLabel: window.__mt.ln.ok,
        cancelLabel: window.__mt.ln.cancel,
      },
    });

    calendarPickup();
    var t = window.__mt.fn.getDate(vm.data.trip.pickUpDate - 1);
    $("#arrival_date_c").daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      startDate: arrival_date,
      minDate: today,
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 5,
      drops: "up",
      locale: {
        format: format,
        daysOfWeek: window.__mt.setting.format.daysOfWeek,
        monthNames: window.__mt.setting.format.monthNames,
        firstDay: 0,
        applyLabel: window.__mt.ln.ok,
        cancelLabel: window.__mt.ln.cancel,
      },
    });

    calendarPickupExtra();

    var pickupMinDate = window.__mt.fn.getDate(vm.data.trip.pickUpDate) || today;
    $("#dropoff_departure_date").daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      startDate: dropoffdate,
      minDate: pickupMinDate,
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 5,
      drops: "up",
      locale: {
        format: format,
        daysOfWeek: window.__mt.setting.format.daysOfWeek,
        monthNames: window.__mt.setting.format.monthNames,
        firstDay: 0,
        applyLabel: window.__mt.ln.ok,
        cancelLabel: window.__mt.ln.cancel,
      },
    });

    calendarDropOff();
  }

  function getTimeDelay(delay, type) {
    var time = delay;
    if (delay == 0 || delay == 2) {
      switch (type) {
        case "airport":
          time = window.__mt.setting.minimum_time_airport + delay;
          break;
        case "train_station":
          time = window.__mt.setting.minimum_time_train + delay;
          break;
        case "port":
          time = window.__mt.setting.minimum_time_port + delay;
          break;
        default:
          time = delay;
          break;
      }
    }

    return time;
  }

  function calendarPickup(calentim) {
    $("#arrival_date").on("show.daterangepicker", function(ev, picker) {
      getMessagePicker("pickup");
    });

    $("#arrival_date").on("hide.daterangepicker", function(ev, picker) {
      var currentDate = picker.startDate;
      var $datetimepicker = currentDate.format(format);

      $scope.$apply(() => {
        vm.data.trip.pickUpDate = $datetimepicker;
        vm.data.trip.arrivalTransportDate = $datetimepicker;
        // Si departure es anterior al nuevo pickup, ajustar
        if (vm.data.trip.departureTransportDate && moment(vm.data.trip.departureTransportDate, format).isBefore(moment($datetimepicker, format))) {
          vm.data.trip.departureTransportDate = $datetimepicker;
        }
      });

      var today = window.__mt.fn.getDate();
      $("#arrival_date").daterangepicker({
        singleDatePicker: true,
        autoApply: true,
        startDate: vm.data.trip.pickUpDate,
        minDate: today,
        timePicker: true,
        timePicker24Hour: true,
        timePickerIncrement: 5,
        drops: "up",
        locale: {
          format: format,
          daysOfWeek: window.__mt.setting.format.daysOfWeek,
          monthNames: window.__mt.setting.format.monthNames,
          firstDay: 0,
          applyLabel: window.__mt.ln.ok,
          cancelLabel: window.__mt.ln.cancel,
        },
      });
      calendarPickup();

      // Reinicializar departure datepicker con minDate = nuevo pickup
      if (vm.data.trip.departureTransportDate) {
        var pickupMinArr = window.__mt.fn.getDate($datetimepicker) || today;
        $("#dropoff_departure_date").daterangepicker({
          singleDatePicker: true,
          autoApply: true,
          startDate: vm.data.trip.departureTransportDate,
          minDate: pickupMinArr,
          timePicker: true,
          timePicker24Hour: true,
          timePickerIncrement: 5,
          drops: "up",
          locale: {
            format: format,
            daysOfWeek: window.__mt.setting.format.daysOfWeek,
            monthNames: window.__mt.setting.format.monthNames,
            firstDay: 0,
            applyLabel: window.__mt.ln.ok,
            cancelLabel: window.__mt.ln.cancel,
          },
        });
        calendarDropOff();
      }
    });
  }

  function calendarPickupExtra(calentim) {
    $("#arrival_date_c").on("show.daterangepicker", function(ev, picker) {
      getMessagePicker("");
    });
    $("#arrival_date_c").on("hide.daterangepicker", function(ev, picker) {
      vm.msn.selected = "";
      var currentDate = picker.startDate;
      var $datetimepicker = currentDate.format(format);
      var today = window.__mt.fn.getDate();

      $scope.$apply(() => {
        vm.data.trip.pickUpDate = $datetimepicker;
      });

      var pickupMin = window.__mt.fn.getDate($datetimepicker) || today;
      var departureStart = vm.data.trip.departureTransportDate || $datetimepicker;
      // Si departure es anterior al nuevo pickup, ajustar al pickup
      if (moment(departureStart, format).isBefore(moment($datetimepicker, format))) {
        departureStart = $datetimepicker;
        vm.data.trip.departureTransportDate = $datetimepicker;
      }
      $("#dropoff_departure_date").daterangepicker({
        singleDatePicker: true,
        autoApply: true,
        startDate: departureStart,
        minDate: pickupMin,
        timePicker: true,
        timePicker24Hour: true,
        timePickerIncrement: 5,
        drops: "up",
        locale: {
          format: format,
          daysOfWeek: window.__mt.setting.format.daysOfWeek,
          monthNames: window.__mt.setting.format.monthNames,
          firstDay: 0,
          applyLabel: window.__mt.ln.ok,
          cancelLabel: window.__mt.ln.cancel,
        },
      });
      calendarDropOff();
    });
  }

  function calendarDropOff(calentim, currentDate) {
    $("#dropoff_departure_date").on("show.daterangepicker", function(ev, picker) {
      getMessagePicker("pickup");
    });
    $("#dropoff_departure_date").on("hide.daterangepicker", function(ev, picker) {
      vm.msn.selected = "";
      var currentDate = picker.startDate;
      var $datetimepicker = currentDate.format(format);
      var today = window.__mt.fn.getDate();

      $scope.$apply(() => {
        vm.data.trip.departureTransportDate = $datetimepicker;
      });

      var pickupMinDep = window.__mt.fn.getDate(vm.data.trip.pickUpDate) || today;
      $("#dropoff_departure_date").daterangepicker({
        singleDatePicker: true,
        autoApply: true,
        startDate: vm.data.trip.departureTransportDate,
        minDate: pickupMinDep,
        timePicker: true,
        timePicker24Hour: true,
        timePickerIncrement: 5,
        drops: "up",
        locale: {
          format: format,
          daysOfWeek: window.__mt.setting.format.daysOfWeek,
          monthNames: window.__mt.setting.format.monthNames,
          firstDay: 0,
          applyLabel: window.__mt.ln.ok,
          cancelLabel: window.__mt.ln.cancel,
        },
      });
      calendarDropOff();
    });
  }



  function getDistance() {
    origin =
      vm._search_confirm.search_from.lat +
      "," +
      vm._search_confirm.search_from.lng;
    destination =
      vm._search_confirm.search_to.lat + "," + vm._search_confirm.search_to.lng;

    var params = {
      params: {
        origins: origin,
        destinations: destination,
      },
    };
    $http
      .get(window.__mt.setting.api_distance, params)
      .then(onSuccessDistance, null);
  }

  function onSuccessDistance(data) {
    var response = data.data;
    if (response.status == "OK") {
      var distance = {};
      distance.data = response;
      distance.origin = origin;
      distance.destination = destination;
      _distance = distance;
      setDistance();
    }
  }

  function setDistance() {
    if (_distance) {
      if (_distance.data && _distance.data.rows && _distance.data.rows.length) {
        vm.distance = _distance.data.rows[0].elements.length
          ? _distance.data.rows[0].elements[0]
          : vm.distance;
        initPickers();
      }
    }
  }

  /*** SEARCH ***/
  window.map_load = window.map_load || null;
  var marker;
  var map;
  var _list = "";
  var autocompleteService;
  var params = {};
  var service;
  var stripe = Stripe(window.__mt.setting.stripe);
  var aux_trip = {};
  vm.loading_search = false;
  vm.loading = false;
  vm.loadingVehicles = false;
  vm.routeChangeError = false;
  vm.results = [];
  vm.results_gm = [];
  vm.results_to = [];
  vm.results_gm_to = [];
  vm.results_pr = [];
  vm.results_pr_to = [];
  vm.search_in_places = false;
  vm.search_in_places_to = false;
  vm.qt = {
    type: "oneway",
    rs: true,
  };
  vm.nTransport = {};
  vm._search = {
    adults: 1,
    children: 0,
    infants: 0,
    search_from: {},
    search_to: {},
  };

  vm._search_confirm = {
    adults: 1,
    children: 0,
    infants: 0,
    search_from: {},
    search_to: {},
  };

  vm._edit = {
    from: false,
    to: false,
  };
  vm.valid_confirm = false;

  vm.search = function(v, model, type) {
    vm[v] = true;
    if (type == "from") {
      vm.results = [];
      vm.results_gm = [];
      vm.results_pr = [];
      _list = "";
    } else {
      vm.results_to = [];
      vm.results_gm_to = [];
      vm.results_pr_to = [];
      _list = "_to";
    }
    if (!model && model.length < 2) {
      return;
    }

    vm.loading_search = true;

    params = {
      params: {
        query: model,
        lang: window.__mt.ln.lang,
      },
    };

    // Solo busca en la API de MyTransfers, NO en Google Maps
    get(window.__mt.setting.api_search, params)
      .then(responseMT)
      .catch(null);
  };

  vm.searchInPlaces = function(show, type) {
    // Activa el flag para indicar que se quiere buscar en Google Maps
    if (type == "_to") {
      vm.search_in_places_to = true;
    } else {
      vm.search_in_places = true;
    }

    vm.loading_search = true;
    findInPlaces();
  };

  function findInPlaces() {
    // Limpia las predictions para mostrar resultados de Google
    vm["results_pr" + _list] = [];

    // Carga el script de Google Maps si no existe
    if (!map_load && !window.google) {
      window.__mt.fn.getScript(
        window.__mt.setting.google_map,
        {},
        onLoadResults
      );
    } else {
      onLoadResults();
    }
    vm.loading_search = false;
  }

  vm.editReservation = function(type, val) {
    vm._edit[type] = val; //vm._edit.from
  };

  vm.iconType = function(item) {
    var icon = "";
    var type = item.type || getTypeGM(item);
    switch (type) {
      case "train_station":
        icon = "fa fa-train";
        break;
      case "port":
        icon = "fa fa-ship";
        break;
      case "airport":
        icon = "fa fa-plane";
        break;
      default:
        icon = "fa fa-map-marker";
        break;
    }
    return [icon];
  };

  // Verificar si hay cambios importantes que requieren mostrar "New modifications"
  vm.hasImportantChanges = function() {
    // Validar que existan los objetos necesarios
    if (!vm.old_data || !vm.data || !vm.car) return false;
    if (!vm.old_data.car || !vm.old_data.trip || !vm.data.trip) return false;

    // Cambio de vehículo
    if (!vm.hasChangeField(vm.old_data.car.transportId, vm.car.transportId, 'vehicle')) return true;

    // Cambios de pasajeros
    if (!vm.hasChangeField(vm.old_data.adults, vm.data.adults, 'adults')) return true;
    if (!vm.hasChangeField(vm.old_data.children, vm.data.children, 'children')) return true;
    if (!vm.hasChangeField(vm.old_data.infants, vm.data.infants, 'infants')) return true;

    // Cambios de ruta
    if (!vm.hasChangeField(vm.old_data.trip.pickup, vm.data.trip.pickup, 'pickup')) return true;
    if (!vm.hasChangeField(vm.old_data.trip.dropoff, vm.data.trip.dropoff, 'dropoff')) return true;

    // Cambios de fechas
    if (!vm.hasChangeField(vm.old_data.trip.pickUpDate, vm.data.trip.pickUpDate, 'pickupDate')) return true;
    if (!vm.hasChangeField(vm.old_data.trip.departureTransportDate, vm.data.trip.departureTransportDate, 'flightDate')) return true;

    // Cambios de información de transporte
    if (!vm.hasChangeField(vm.old_data.trip.arrivalTransportLine, vm.data.trip.arrivalTransportLine, 'airline')) return true;
    if (!vm.hasChangeField(vm.old_data.trip.arrivalTransportLocator, vm.data.trip.arrivalTransportLocator, 'flight')) return true;
    if (!vm.hasChangeField(vm.old_data.trip.departureTransportLine, vm.data.trip.departureTransportLine, 'airline')) return true;
    if (!vm.hasChangeField(vm.old_data.trip.departureTransportLocator, vm.data.trip.departureTransportLocator, 'flight')) return true;

    // Cambios de cliente
    if (!vm.hasChangeField(vm.old_data.customerFirstName, vm.data.customerFirstName, 'firstName')) return true;
    if (!vm.hasChangeField(vm.old_data.customerLastName, vm.data.customerLastName, 'lastName')) return true;
    if (!vm.hasChangeField(vm.old_data.customerEmail, vm.data.customerEmail, 'email')) return true;
    if (!vm.hasChangeField(vm.old_data.customerPhone, vm.data.customerPhone, 'phone')) return true;
    if (!vm.hasChangeField(vm.old_data.customerCountry, vm.data.customerCountry, 'country')) return true;

    return false;
  };

  vm.acceptChange = function() {
    if (vm.qt.type == "options" && vm.qt.transport) {
      vm.qt.selected = true;
      vm.car = vm.qt.transport;
      $("#c-modal-notification").modal("hide");
    }

    if (vm.qt.type == "no-found") {
      vm.totalPassages =
        Number.parseInt(vm.data.children) +
        Number.parseInt(vm.data.adults) +
        Number.parseInt(vm.data.infants);
      $("#c-modal-notification").modal("hide");
      /**save people child, infants and adults**/
      if (savedPassager && validPassagers()) {
        if (vm.car && vm.car.maxPassengers && vm.totalPassages > vm.car.maxPassengers) {
          vm.showChangePassagers = true;
          savedPassager = false;
          $("#pax-view-pro").toggle();
        } else {
          vm.data.savePassager = true;
          vm.qt.rs = true;
        }
      }
      /**save route pickup or dropoff**/
      if (savedRoute) {
        /**
                if(total <= vm.data.car.maxPassengers){
                    vm.data.saveTypeDestination = true;
                    vm.qt.rs = true;
                }else{
                    vm.data.saveTypeDestination = false;
                }
                 **/
      }
    }
  };

  vm.selectResult = function(item, source, type, show, dt) {
    vm[show] = false;

    if (source == "mt") {
      vm._search_confirm[type] = item.name;
      vm._search_confirm[type + "_view"] = item.name;
    } else {
      vm._search_confirm[type] =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
      vm._search_confirm[type + "_view"] =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
    }

    vm._search_confirm["search_" + type] = item;
    vm._search_confirm["search_" + type].source = source;

    //vm.editReservation(type, false);
    changePoint(item, dt, type);
    showTooltip(type, item);
  };

  vm.closeChangeRoute = function() {
    // 1. Validar inputs de address si aplica
    var pickupIsAddress = vm.data.trip.pickupType == "address";
    var dropoffIsAddress = vm.data.trip.dropoffType == "address";

    if (pickupIsAddress && vm._search_confirm.from_view && !vm._search_confirm.from) {
      vm.valid_confirm = true;
      return;
    }
    if (dropoffIsAddress && vm._search_confirm.to_view && !vm._search_confirm.to) {
      vm.valid_confirm = true;
      return;
    }

    // 2. Detectar si hay algún cambio vs old_data
    var hasChanges = false;
    if (vm.old_data && vm.old_data.trip) {
      hasChanges = vm.data.trip.pickUpDate !== vm.old_data.trip.pickUpDate ||
        vm.data.trip.departureTransportDate !== vm.old_data.trip.departureTransportDate ||
        vm.data.trip.arrivalTransportLine !== vm.old_data.trip.arrivalTransportLine ||
        vm.data.trip.arrivalTransportLocator !== vm.old_data.trip.arrivalTransportLocator ||
        vm.data.trip.departureTransportLine !== vm.old_data.trip.departureTransportLine ||
        vm.data.trip.departureTransportLocator !== vm.old_data.trip.departureTransportLocator;
    }

    // Detectar cambio de dirección
    var hasRouteChanges = (pickupIsAddress && vm._search_confirm.from && vm._search_confirm.from !== vm.data.trip.pickup) ||
        (dropoffIsAddress && vm._search_confirm.to && vm._search_confirm.to !== vm.data.trip.dropoff);

    // 3. Si no hay cambios, solo cerrar
    if (!hasChanges && !hasRouteChanges) {
      vm.valid_confirm = false;
      vm.closeEditingSection();
      return;
    }

    // 4. Limpiar validación y preparar
    vm.valid_confirm = false;
    vm._edit.from = false;
    vm.routeChangeError = false;
    vm.dateChangeError = false;

    // Backup para poder revertir si el requote falla
    if (hasRouteChanges) {
      savedRoute = true;
      vm._backup_search = {
        from: angular.copy(vm.data.trip.pickup),
        to: angular.copy(vm.data.trip.dropoff),
        search_from: angular.copy(vm._search_confirm.search_from),
        search_to: angular.copy(vm._search_confirm.search_to),
      };
      // Completar el lado que no cambió
      if (pickupIsAddress && !vm._search_confirm.to) {
        vm._search_confirm.to = vm.data.trip.dropoff;
      }
      if (dropoffIsAddress && !vm._search_confirm.from) {
        vm._search_confirm.from = vm.data.trip.pickup;
      }
      changeConfirmTrip();
    }

    // Backup de fechas
    vm._backup_date = {
      pickUpDate: vm.old_data.trip.pickUpDate,
      arrivalTransportDate: vm.old_data.trip.arrivalTransportDate,
      departureTransportDate: vm.old_data.trip.departureTransportDate
    };

    // 5. Hacer requote con toda la info actualizada
    vm.loadingRoute = true;
    requote();
    showAlert(vm.data.trip, false);
  };

  vm.resetRouteChanges = function() {
    // Restaurar valores antiguos si existen
    if (vm._backup_search) {
      vm.data.trip.pickup = vm._backup_search.from;
      vm.data.trip.dropoff = vm._backup_search.to;

      if (vm._backup_search.search_from) {
        vm._search_confirm.search_from = vm._backup_search.search_from;
      }
      if (vm._backup_search.search_to) {
        vm._search_confirm.search_to = vm._backup_search.search_to;
      }

      // Limpiar los campos de texto que el usuario escribió
      vm._search_confirm.from = false;
      vm._search_confirm.to = false;
      vm._search_confirm.from_view = '';
      vm._search_confirm.to_view = '';

      delete vm._backup_search;
    }

    savedRoute = false;

    // Ocultar el error DESPUÉS de restaurar los valores
    vm.routeChangeError = false;
    vm.routeChangeErrorType = null;
  };

  // Función para restaurar la fecha original cuando no hay disponibilidad
  vm.resetDateChange = function() {
    if (vm._backup_date) {
      vm.data.trip.pickUpDate = vm._backup_date.pickUpDate;
      vm.data.trip.arrivalTransportDate = vm._backup_date.arrivalTransportDate;
      if (vm._backup_date.departureTransportDate) {
        vm.data.trip.departureTransportDate = vm._backup_date.departureTransportDate;
      }
      vm._backup_date = null;
    }
    vm.dateChangeError = false;
    vm.pickup_departure = true;
    vm.qt = { type: "oneway", rs: true };
  };

  // Función para manejar la acción del botón en la alerta de cambio de fecha
  vm.handleDateChangeAlert = function() {
    vm.resetDateChange();
  };

  // Función para manejar la acción del botón en la alerta de cambio de ruta
  vm.handleRouteChangeAlert = function() {
    if (vm.routeChangeErrorType === 'no-found') {
      // Si no hay vehículos, restaurar valores y cerrar la edición
      vm.resetRouteChanges();
      vm.closeEditingSection();
    } else if (vm.routeChangeErrorType === 'options') {
      // Si necesita cambiar vehículo, limpiar error y abrir sección de vehículos
      vm.routeChangeError = false;
      vm.closeEditingSection(); // Cerrar edición de ruta
      vm.setEditingSection('vehicle'); // Abrir sección de vehículos
      // Mantener vm._backup_search para poder restaurar si cancela
    }
  };

  // Función unificada para resetear todos los cambios de ruta/fecha cuando hay error
  vm.resetRouteErrors = function() {
    vm.resetAllChanges();
    vm.routeChangeError = false;
    vm.routeChangeErrorType = null;
    vm.dateChangeError = false;
  };

  vm.onFocus = function(show, type) {
    if (vm["results" + type].length || vm["results_gm" + type].length) {
      vm[show] = true;
    }
  };

  vm.listCars = function() {
    if (vm.data.bookingType === 'MyDisposition' || vm.data.bookingType === 'DisBooking') {
      return;
    }
    getAllAvailableCars = true;
    vm.showVehicleOptions = true;
    vm.loadingVehicles = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (vm.data.bookingType === 'DisBooking') {
      requoteDisposition();
    } else {
      requote(true);
    }
  };

  function requoteDisposition() {
    var from = vm._search_confirm.search_from || {};
    var originLat = from.lat
      || (from.geometry && from.geometry.location && typeof from.geometry.location.lat === 'function'
            ? from.geometry.location.lat()
            : (from.geometry && from.geometry.location && from.geometry.location.lat))
      || vm.data.trip.pickUpLat;
    var originLng = from.lng
      || (from.geometry && from.geometry.location && typeof from.geometry.location.lng === 'function'
            ? from.geometry.location.lng()
            : (from.geometry && from.geometry.location && from.geometry.location.lng))
      || vm.data.trip.pickUpLng;

    if (!originLat || !originLng) {
      vm.loadingVehicles = false;
      vm.qt = { type: 'no-found', rs: false };
      $scope.$applyAsync();
      return;
    }

    var params = {
      params: {
        arrival_lat:  originLat,
        arrival_lng:  originLng,
        adults:       vm._search_confirm.adults   || vm.data.adults   || 1,
        children:     vm._search_confirm.children || vm.data.children || 0,
        infants:      vm._search_confirm.infants  || vm.data.infants  || 0,
        hours:        vm.data.trip.hours || 1,
        lang:         window.__mt.ln.lang,
        arrival_date: vm.data.trip.pickUpDate,
      }
    };

    $http.get(window.__mt.setting.api_disposition_list, params)
      .then(onDispositionListSuccess, onRequoteError);
  }

  function onDispositionListSuccess(data) {
    vm.loadingVehicles = false;
    vm.loadingRoute    = false;
    vm.loading         = false;
    var response = data.data;

    if (response.code !== 200 || !response.response || !response.response.transferPriceList) {
      vm.qt = { type: 'no-found', rs: false };
      $scope.$applyAsync();
      return;
    }

    var vehicles = response.response.transferPriceList || [];
    if (!vehicles.length) {
      vm.qt = { type: 'no-found', rs: false };
      $scope.$applyAsync();
      return;
    }

    var options = {};
    vehicles.forEach(function(v, i) {
      options[i] = {
        transportId:   v.transportId,
        transferId:    v.transferId,
        transportName: v.transportName,
        imageURL:      v.imageURL,
        maxPassengers: v.maxPassengers,
        minPassengers: v.minPassengers || 1,
        price:         v.price,
        suitcases:     v.suitcases || 0,
        providerId:    v.providerId,
        providerName:  v.providerName || '',
        extras:        v.extras || [],
        pack:          v.pack || v.category || null,
      };
    });
    options.allTransfers = vehicles;

    vm._dispositionSessionData = response.response;
    vm.qt = { type: 'options', options: options, code: 200, rs: true };
    $scope.$applyAsync();
  }

  vm.selectOption = function(car) {
    optionCarDeselect();
    car.selected = true;
    vm.qt.transport = car;
    vm.qt.rs = true;
    vm.acceptChange();
    vm.car = car;

    vm.showVehicleOptions = false;
    vm.loadingVehicles = false;
    vm.editingSection = null;
    vm.tempData = null;

    // Scroll a la sección de información del vehículo
    $timeout(function() {
      var el = document.getElementById('vehicle-info-section');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Si venimos de un cambio de ruta exitoso, limpiar el backup
    if (vm._backup_search) {
      delete vm._backup_search;
      vm.routeChangeError = false;
      vm.routeChangeErrorType = null;
    }

    // Abrir modal de confirmación directamente al seleccionar vehículo
    vm.save();
  };

  vm.showPrice = function(option) {
 
    var text = 0;
    if (
      vm.data &&
      option &&
      vm.data.price &&
      vm.data.price.totalPrice < option.price
    ) {
      text = (option.price - vm.data.price.totalPrice) * vm.exchange_convertion;
    }
    return text;
  };

  vm.save = function() {
    vm.submit = true;
    vm.confirm_email = validConfirmEmail();

    if (vm.car && vm.car.maxPassengers && vm.totalPassages > vm.car.maxPassengers) {
      //defaultPassagers();
      // NOTA: No se resetea vm.submit a false aquí para que los campos inválidos
      // mantengan la clase 'is-invalid' visible para el usuario
      // vm.submit = false;
      return 0;
    }

    if (
      !vm.form ||
      !vm.form.$valid ||
      !vm.pickup_departure ||
      !vm.confirm_email
    ) {
      // NOTA: No se resetea vm.submit a false cuando la validación falla
      // Esto permite que ng-class aplique 'is-invalid' a los campos que tienen errores
      // Anteriormente se establecía vm.submit = false aquí, lo que impedía mostrar los errores
      // vm.submit = false;
      return 0;
    }

    // console.log('=== SAVE DEBUG ===');
    // console.log('hasChanges():', hasChanges());
    // console.log('vm.qt:', vm.qt);
    // console.log('vm.qt.rs:', vm.qt ? vm.qt.rs : 'undefined');
    // console.log('vm.qt.type:', vm.qt ? vm.qt.type : 'undefined');

    if (hasChanges() && vm.qt && vm.qt.rs && vm.qt.type != "no-found") {
      $("#c-modal-confirmation").modal("show");
      // console.log("HUBO CAMBIO");
    } else {
      vm.submit = false;
      $("#c-modal-edit").modal("hide");
      // console.log("NO HUBO CAMBIO o NO CUMPLE CON LA SELECCION");
      // console.log('Razón:');
      // console.log('- hasChanges():', hasChanges());
      // console.log('- vm.qt existe:', !!vm.qt);
      // console.log('- vm.qt.rs:', vm.qt ? vm.qt.rs : 'undefined');
      // console.log('- vm.qt.type != "no-found":', vm.qt ? (vm.qt.type != "no-found") : 'undefined');
    }
  };

  vm.onSave = function() {
    onSave();
  };

  vm.isHubToHub = function(quote) {
    return (
      quote && quote.dropoffType != "address" && quote.pickupType != "address"
    );
  };

  vm.cancelChangeRoute = function() {
    // Limpiar dropdowns y estado de edición
    vm.showfrom = false;
    vm.showto = false;
    vm._edit.from = false;
    vm.valid_confirm = false;
    vm.routeChangeError = false;
    vm.routeChangeErrorType = null;
    vm.dateChangeError = false;
    vm.loadingRoute = false;
    vm.pickup_departure = true;
    vm._backup_search = null;
    vm._backup_date = null;
    savedRoute = false;

    // Restaurar valores originales de la ruta desde old_data
    if (vm.old_data && vm.old_data.trip) {
      vm.data.trip.pickup = vm.old_data.trip.pickup;
      vm.data.trip.dropoff = vm.old_data.trip.dropoff;
      vm.data.trip.pickupType = vm.old_data.trip.pickupType;
      vm.data.trip.dropoffType = vm.old_data.trip.dropoffType;
      vm.data.trip.pickUpLat = vm.old_data.trip.pickUpLat;
      vm.data.trip.pickUpLng = vm.old_data.trip.pickUpLng;
      vm.data.trip.dropoffLat = vm.old_data.trip.dropoffLat;
      vm.data.trip.dropoffLng = vm.old_data.trip.dropoffLng;
      vm.data.trip.arrivalTransportLocator =
        vm.old_data.trip.arrivalTransportLocator;
      vm.data.trip.arrivalTransportLine = vm.old_data.trip.arrivalTransportLine;
      vm.data.trip.pickUpDate = vm.old_data.trip.pickUpDate;
      vm.data.trip.departureTransportDate =
        vm.old_data.trip.departureTransportDate;
      vm.data.trip.departureTransportLocator =
        vm.old_data.trip.departureTransportLocator;
    }

    // Restaurar _search_confirm con los datos originales
    vm._search_confirm.from = vm.data.trip.pickup;
    vm._search_confirm.to = vm.data.trip.dropoff;
    vm._search_confirm.from_view = vm.data.trip.pickup;
    vm._search_confirm.to_view = vm.data.trip.dropoff;
    vm._search_confirm.search_from = {
      id: 1,
      lat: vm.data.trip.pickUpLat,
      lng: vm.data.trip.pickUpLng
    };
    vm._search_confirm.search_to = {
      id: 1,
      lat: vm.data.trip.dropoffLat,
      lng: vm.data.trip.dropoffLng
    };

    // Restaurar qt al estado original
    vm.qt = { type: "oneway", rs: true };
  };

  vm.resetAllChanges = function() {
    if (!vm.old_data) {
      return;
    }

    // Restaurar información del cliente
    vm.data.customerFirstName = vm.old_data.customerFirstName;
    vm.data.customerLastName = vm.old_data.customerLastName;
    vm.data.customerEmail = vm.old_data.customerEmail;
    vm.data.customerPhone = vm.old_data.customerPhone;
    vm.data.customerCountry = vm.old_data.customerCountry;
    vm.data.specialRequirements = vm.old_data.specialRequirements;

    // Restaurar pasajeros
    vm.data.adults = vm.old_data.adults;
    vm.data.children = vm.old_data.children;
    vm.data.infants = vm.old_data.infants;
    vm.totalPassages =
      Number.parseInt(vm.data.children) +
      Number.parseInt(vm.data.adults) +
      Number.parseInt(vm.data.infants);

    // Restaurar vehículo
    if (vm.old_data.car) {
      vm.car = angular.copy(vm.old_data.car);
    }

    // NO restaurar vm.data.transport_id/provider_id/provider_price_id
    // porque vm.car ya contiene toda la información necesaria
    // y estos campos se manejan automáticamente en el backend

    // Restaurar información de la ruta
    if (vm.old_data.trip) {
      vm.data.trip.pickup = vm.old_data.trip.pickup;
      vm.data.trip.dropoff = vm.old_data.trip.dropoff;
      vm.data.trip.pickupType = vm.old_data.trip.pickupType;
      vm.data.trip.dropoffType = vm.old_data.trip.dropoffType;
      vm.data.trip.pickUpLat = vm.old_data.trip.pickUpLat;
      vm.data.trip.pickUpLng = vm.old_data.trip.pickUpLng;
      vm.data.trip.dropoffLat = vm.old_data.trip.dropoffLat;
      vm.data.trip.dropoffLng = vm.old_data.trip.dropoffLng;
      vm.data.trip.arrivalTransportLocator =
        vm.old_data.trip.arrivalTransportLocator;
      vm.data.trip.arrivalTransportLine = vm.old_data.trip.arrivalTransportLine;
      vm.data.trip.pickUpDate = vm.old_data.trip.pickUpDate;
      vm.data.trip.departureTransportDate =
        vm.old_data.trip.departureTransportDate;
      vm.data.trip.departureTransportLocator =
        vm.old_data.trip.departureTransportLocator;
      vm.data.trip.departureTransportLine =
        vm.old_data.trip.departureTransportLine;
    }

    // Limpiar estados de edición
    vm.editingSection = null;
    vm.showfrom = false;
    vm.showto = false;
    vm._edit.from = false;

    // Limpiar cambios temporales en _search_confirm
    vm._search_confirm.from = null;
    vm._search_confirm.to = null;
    vm._search_confirm.from_view = null;
    vm._search_confirm.to_view = null;

    // Restaurar coordenadas originales desde _search_confirm guardado
    if (vm.old_data._search_confirm) {
      vm._search_confirm.search_from = angular.copy(vm.old_data._search_confirm.search_from);
      vm._search_confirm.search_to = angular.copy(vm.old_data._search_confirm.search_to);
      vm._search_confirm.adults = vm.old_data._search_confirm.adults;
      vm._search_confirm.children = vm.old_data._search_confirm.children;
      vm._search_confirm.infants = vm.old_data._search_confirm.infants;
    } else {
      // Fallback: intentar desde vm.old_data directamente
      vm._search_confirm.adults = vm.old_data.adults;
      vm._search_confirm.children = vm.old_data.children;
      vm._search_confirm.infants = vm.old_data.infants;
    }

    // Limpiar requote - inicializar con valor por defecto en lugar de null
    vm.qt = {
      type: "oneway",
      rs: true,
    };

    // Resetear vista de opciones de vehículos
    vm.showVehicleOptions = false;

    // Resetear validaciones
    vm.submit = false;
  };

  vm.onCloseConfirmation = function() {
    vm.submit = false;
    vm.saveSuccess = false;
    vm.saveError = false;
    vm.savingConfirmation = false;
    vm.saveStripeRedirect = false;
    textChange = "";
    $("#c-modal-confirmation").modal("hide");
    // Resetear todos los cambios si se cierra sin confirmar (no después de success/error)
    vm.resetAllChanges();
  };

  vm.getTotalReservation = function(obj = {}) {
    if (obj.currency == currencyDefault) {
      return obj.totalPrice * vm.exchange_convertion;
    }

    return obj.totalPrice || 0;
  };

  vm.getCurrencyReservation = function(obj = {}) {
    if (obj.currency == currencyDefault) {
      return vm.ln.currency_code;
    }
    return obj.currency || currencyDefault;
  };

  function reset() {
    _list = "";
    params = {};
    toggle = false;
    vm.loading_search = false;
    vm.loading = false;
    vm.loadingVehicles = false;
    vm.results = [];
    vm.results_gm = [];
    vm.results_to = [];
    vm.results_gm_to = [];
    vm.results_pr = [];
    vm.results_pr_to = [];
    vm.search_in_places = false;
    vm.search_in_places_to = false;
    vm.qt = {
      type: "oneway",
      rs: true,
    };
    vm.nTransport = {};
    vm._search = {
      adults: 1,
      children: 0,
      infants: 0,
      search_from: {},
      search_to: {},
    };

    vm._search_confirm = {
      adults: 1,
      children: 0,
      infants: 0,
      search_from: {},
      search_to: {},
    };

    aux_trip = {};

    vm._edit = {
      from: false,
      to: false,
    };
    vm.valid_confirm = false;
    vm.statusShowChangeEmail = false;
    vm.data.send_email = "";
    vm.showVehicleOptions = false; // Resetear la vista de opciones de vehículos
    base_price_provider = 0;
  }
  function onSave() {
    vm.loading = true;
    vm.savingConfirmation = true;
    vm.saveSuccess = false;
    vm.saveError = false;
    vm.saveStripeRedirect = false;
    var user = __mt.setting.user || {};
    vm.data.bookingChanges = `\n<br/> ${textChange}`;

    // Validar qt antes de enviar: si tiene qt pero es inválido, no enviar
    if (vm.qt && vm.qt.type === 'options' && (!vm.qt.transport || vm.qt.code != 200)) {
      vm.loading = false;
      vm.savingConfirmation = false;
      vm.saveError = true;
      return;
    }

    var params = {
      data: vm.data,
      qt: vm.qt,
      lang: window.__mt.ln.lang,
    };

    if (iti_r) {
      var country = iti_r.getSelectedCountryData();
      if (country && country.dialCode) {
        phone_number = country.dialCode;
      }
    }

    // Fallback: extract dial code from original booking phone when iti_r was never initialized
    if (!phone_number && _booking && _booking.customerPhone) {
      var _phoneMatch = _booking.customerPhone.match(/\(\+(\d+)\)/);
      if (_phoneMatch) {
        phone_number = _phoneMatch[1];
      }
    }

    params.data.code_customerPhone =
      "(+" + phone_number + ") " + params.data.customerPhone;
    params.data.specialRequirementsAll = setComment(
      last_comment != vm.data.specialRequirements
        ? vm.data.specialRequirements
        : null
    );
    params.booking = _booking;
    params.user_id = user.id;
    params.user_type = user.type;
    // console.log('=== FINAL PARAMS TO SEND ===');
    // console.log('params.qt:', params.qt);
    // console.log('params.qt.transport:', params.qt.transport);
    // console.log('Full params:', params);
    // console.log('JSON.stringify(params.qt):', JSON.stringify(params.qt));
    // console.log('JSON.stringify(params.qt.transport):', JSON.stringify(params.qt.transport));
    $http
      .post(window.__mt.setting.api_edit_reservation, params)
      .then(onSaveSuccess, onSaveError);
  }

  function onSaveSuccess(data) {
    vm.loading = false;
    vm.savingConfirmation = false;
    var response = data.data;
    if (response && response.stripe) {
      // Show redirect countdown in modal
      vm.savingConfirmation = false;
      vm.saveStripeRedirect = true;
      vm.stripeCountdown = 3;
      $scope.$applyAsync();

      var countdownInterval = setInterval(function() {
        vm.stripeCountdown--;
        $scope.$applyAsync();
        if (vm.stripeCountdown <= 0) {
          clearInterval(countdownInterval);
          stripe
            .redirectToCheckout({
              sessionId: response.stripe.id,
            })
            .then(function() {
            });
        }
      }, 1000);
      return;
    }

    // Show success state in the modal
    vm.saveSuccess = true;
    $scope.$applyAsync();

    // Close modal after a delay and refresh the current booking
    $timeout(function() {
      var currentId = _id;
      var currentEmail = vm.data.customerEmail || (vm._s && vm._s.email);

      vm.saveSuccess = false;
      $("#c-modal-confirmation").modal("hide");
      $(".modal").modal("hide");

      vm.editingSection = null;
      vm.showClientInformation = false;
      vm.showVehicleOptions = false;
      vm.submit = false;
      vm.saveStripeRedirect = false;
      vm.savingConfirmation = false;
      vm.saveError = false;
      vm.old_data = {};
      vm.data = {};
      vm.car = {};
      vm.qt = { type: "oneway", rs: true };
      textChange = "";

      // Refrescar datos del booking actual en lugar de ir a la lista
      vm.edit(currentId, currentEmail);
      vm.timeoutStop();
    }, 2000);
  }

  function onSaveError() {
    // console.log(data);
    vm.loading = false;
    vm.savingConfirmation = false;
    vm.saveError = true;
    $scope.$applyAsync();
    vm.timeoutStop();
  }

  function onLoadResults() {
    window.map_load = true;

    if (!autocompleteService) {
      if (!map) {
        onLoadMap();
      }
      autocompleteService = new google.maps.places.AutocompleteService();
      service = new google.maps.places.PlacesService(map);
    }

    autocompleteService.getPlacePredictions(
      {
        input: params.params.query,
      },
      responseGM
    );
  }

  function responseMT(data) {
    var response = data.data;
    vm.loading_search = false;

    if (
      response &&
      response.code == 200 &&
      response.response &&
      !vm.search_in_places &&
      !vm.search_in_places_to
    ) {
      // Manejar resultados principales (destinos de MyTransfers)
      if (
        response.response.destinations &&
        response.response.destinations.length
      ) {
        vm["results" + _list] = response.response.destinations;
      }

      // Manejar predicciones si están presentes
      if (
        response.response.predictions &&
        response.response.predictions.length
      ) {
        // Si hay predictions, usarlas y NO llamar a Google Maps
        vm["results_pr" + _list] = response.response.predictions;
      } else {
        // Si NO hay predictions, llamar a Google Maps
        findInPlaces();
      }
    } else {
      // Si falla la API, llamar a Google Maps
      findInPlaces();
    }
  }

  function responseGM(response, status) {
    if (status == "OK") {
      vm["results_gm" + _list] = response;
    } else {
      vm["results_gm" + _list] = [];
    }
    vm.loading_search = false;
    $scope.$apply();
  }

  function get(url, params) {
    var defered = $q.defer();
    var promise = defered.promise;

    $http.get(url, params).then(
      function(data) {
        defered.resolve(data);
      },
      function(err) {
        defered.reject(err);
      }
    );

    return promise;
  }

  function onLoadMap() {
    window.map_load = true;

    var mapOptions = {
      center: new google.maps.LatLng(40.463667, -3.74922),
      zoom: 6,
      treetViewControl: false,
      mapTypeControl: false,
    };

    map = new google.maps.Map(
      document.getElementById("map_search"),
      mapOptions
    );

    marker = new google.maps.Marker({
      position: new google.maps.LatLng(40.463667, -3.74922),
      draggable: true,
    });
    marker.setMap(map);

    google.maps.event.addListener(marker, "click", function() {
      map.setZoom(9);
      map.setCenter(marker.getPosition());
    });

    google.maps.event.addListener(map, "click", function(event) {
      marker.setPosition(event.latLng);
    });
  }

  function getTypeGM(item) {
    var type = "address";

    if (item.types) {
      if (item.types.indexOf("train_station") != -1) {
        type = "train_station";
      }

      if (item.types.indexOf("airport") != -1) {
        type = "airport";
      }

      if (item.types.indexOf("port") != -1) {
        type = "port";
      }
    }

    return type;
  }

  function changePoint(item, dt, tp) {
    var type = item.type || getTypeGM(item);

    if (tp == "from") {
      aux_trip.pickup =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
      aux_trip.pickupType = type;
    } else {
      aux_trip.dropoff =
        item.name ||
        item.formatted_address ||
        item.description ||
        item.structured_formatting.main_text;
      aux_trip.dropoffType = type;
    }
  }

  function changeConfirmTrip() {
    vm._search = vm._search_confirm;
    vm.data.trip.pickup = aux_trip.pickup || vm.data.trip.pickup;
    vm.data.trip.pickupType = aux_trip.pickupType || vm.data.trip.pickupType;
    vm.data.trip.dropoff = aux_trip.dropoff || vm.data.trip.dropoff;
    vm.data.trip.dropoffType = aux_trip.dropoffType || vm.data.trip.dropoffType;
  }

  function requote(showAll = false) {
    var from = vm._search_confirm.search_from || {};
    var to = vm._search_confirm.search_to || {};

    // Si search_from/to tiene place_id sin geometry, resolver primero
    if (from.place_id && !from.geometry) {
      getPlaceInformation("search_from");
      return;
    }
    if (to.place_id && !to.geometry) {
      getPlaceInformation("search_to");
      return;
    }

    // Convertir geometry.location functions a valores si es necesario
    if (from.geometry && from.geometry.location && typeof from.geometry.location.lat === "function") {
      from.geometry.location.lat = from.geometry.location.lat();
      from.geometry.location.lng = from.geometry.location.lng();
    }
    if (to.geometry && to.geometry.location && typeof to.geometry.location.lat === "function") {
      to.geometry.location.lat = to.geometry.location.lat();
      to.geometry.location.lng = to.geometry.location.lng();
    }

    // Resolver coordenadas: prioridad search_from > geometry > trip actual
    var originLat = from.lat
      || (from.geometry && from.geometry.location && from.geometry.location.lat)
      || vm.data.trip.pickUpLat;
    var originLng = from.lng
      || (from.geometry && from.geometry.location && from.geometry.location.lng)
      || vm.data.trip.pickUpLng;
    var destLat = to.lat
      || (to.geometry && to.geometry.location && to.geometry.location.lat)
      || vm.data.trip.dropoffLat;
    var destLng = to.lng
      || (to.geometry && to.geometry.location && to.geometry.location.lng)
      || vm.data.trip.dropoffLng;

    if (originLat && originLng && destLat && destLng) {
      var user = __mt.setting.user || {};
      var params = {
        adults: vm._search_confirm.adults,
        infants: vm._search_confirm.infants,
        children: vm._search_confirm.children,
        lang: window.__mt.ln.lang,
        pickup_date: vm.data.trip.pickUpDate,
        origin_lat: originLat,
        origin_lng: originLng,
        destination_lat: destLat,
        destination_lng: destLng,
        transport_id: vm.car?.transportId || vm.data.transport_id,
        reservations_type: vm.data.type_reservation ? "roundtrip" : "oneway",
        provider_id: vm.car?.providerId || vm.data.provider_id,
        user_id: user.id,
        user_type: user.type,
        provider_price_id: vm.car?.providerPriceId || vm.data.provider_price_id,
        client_id: vm.data.client_id,
        get_available_cars: showAll,
      };
      // Usar loading específico según el contexto
      if (vm.showVehicleOptions) {
        vm.loadingVehicles = true;
      } else if (vm.editingSection === 'route') {
        vm.loadingRoute = true;
      } else {
        vm.loading = true;
      }
      $http
        .post(window.__mt.setting.api_requote, params)
        .then(onRequoteSuccess, onRequoteError);
    } else {
      // No se pudo hacer requote, limpiar loading
      vm.loading = false;
      vm.loadingVehicles = false;
      vm.loadingRoute = false;
      $scope.$applyAsync();
    }
  }

  function onRequoteSuccess(data) {
    vm.loading = false;
    vm.loadingVehicles = false;
    vm.loadingRoute = false;
    var response = data.data;

    // Normalizar el código a string para comparaciones consistentes
    var responseCode = String(response.code);

    // CASO 1: Error del API (500, error, noAvailability, etc)
    if (responseCode !== "200" || response.error || response.noAvailability === true) {
      // Si hay un cambio de ruta pendiente, mostrar alerta
      if (vm._backup_search) {
        vm.routeChangeError = true;
        vm.routeChangeErrorType = 'no-found';
      } else if (vm._backup_date) {
        // Si hay cambio de fecha pendiente, mostrar alerta de fecha
        vm.dateChangeError = true;
      } else if (vm.showVehicleOptions) {
        // Mantener showVehicleOptions = true para que se muestre el mensaje de no-found en la vista
      }
      // Establecer estado no-found
      vm.qt = { type: "no-found", rs: false };
      return;
    }

    // CASO 2: Respuesta exitosa (200)
    requiredSelectVehicle(response);

    switch (response.type) {
      case "options":
        if (response.options) {
          var vehicleList = Object.values(response.options).filter(function(opt) {
            return opt && typeof opt === 'object' && opt.transportName;
          });
          vehicleList = vehicleList.filter(vehicleHasBookedExtras);
          if (!vehicleList.length) {
            response.type = "no-found";
          }
          var filtered = {};
          vehicleList.forEach(function(v, i) { filtered[i] = v; });
          filtered.allTransfers = response.options.allTransfers;
          filtered.searchedTransfer = response.options.searchedTransfer;
          response.options = filtered;
        }
        vm.qt = response;
        if (vm._backup_search) {
          vm.routeChangeError = true;
          vm.routeChangeErrorType = 'options';
        } else {
          $("#c-modal-notification").modal("show");
        }
        break;

      case "no-found":
        // No se encontraron vehículos
        vm.qt = response;
        vm.qt.rs = false;
        if (vm._backup_search) {
          vm.routeChangeError = true;
          vm.routeChangeErrorType = 'no-found';
        } else if (vm._backup_date) {
          // Si hay cambio de fecha pendiente, mostrar alerta de fecha
          vm.dateChangeError = true;
        } else if (vm.showVehicleOptions) {
          // Mantener showVehicleOptions = true para que se muestre el mensaje de no-found en la vista
        } else {
          $("#c-modal-notification").modal("show");
        }
        break;

      case "oneway":
      case "roundtrip":
        // Vehículo válido encontrado
        vm.qt = response;
        vm.qt.transport = response.response.transfer;
        if (base_price_provider == vm.qt.transport.providerPrice) {
          vm.qt.transport.price = vm.data.price.totalPrice;
        }
        vm.qt.rs = true;

        // Limpiar backups
        vm._backup_search = null;
        vm._backup_date = null;
        vm.routeChangeError = false;
        vm.routeChangeErrorType = null;
        vm.dateChangeError = false;

        // Cerrar sección de ruta si estábamos editando y abrir modal
        if (vm.editingSection === 'route') {
          vm.closeEditingSection();
          vm.save();
        }
        break;
    }

    labelTrip();
  }

  function onRequoteError(data) {
    vm.loading = false;
    vm.loadingVehicles = false;
    vm.loadingRoute = false;
    console.error('Error en requote:', data);

    // Mostrar alerta si hay cambio de ruta pendiente
    if (vm._backup_search) {
      vm.routeChangeError = true;
      vm.routeChangeErrorType = 'no-found';
    } else if (vm._backup_date) {
      vm.dateChangeError = true;
    } else if (vm.showVehicleOptions) {
      // Mantener showVehicleOptions = true para que se muestre el mensaje de no-found en la vista
    }

    // Establecer estado no-found
    vm.qt = { type: "no-found", rs: false };
  }

  function getPlaceInformation(type) {
    var item = vm._search[type];

    // Si el item ya tiene lat/lng directamente (predictions), usarlos sin llamar a Google
    if (item.lat && item.lng) {
      vm._search[type].geometry = {
        location: {
          lat: item.lat,
          lng: item.lng,
        },
      };
      requote();
      return;
    }

    // Si tiene place_id pero service no está inicializado, mostrar error
    if (!service) {
      console.error("Google Maps service not initialized");
      vm.routeChangeError = true;
      if (vm._backup_search) {
        vm.resetRouteChanges();
      }
      $scope.$apply();
      return;
    }

    var request = {
      placeId: item.place_id,
      fields: ["name", "rating", "formatted_phone_number", "geometry"],
    };
    service.getDetails(request, (response) => {
      vm._search[type] = vm._search[type] || {};
      vm._search[type].geometry = {};
      vm._search[type].geometry.location = {};
      vm._search[type].geometry.location.lat = response.geometry.location.lat();
      vm._search[type].geometry.location.lng = response.geometry.location.lng();
      $scope.$apply();
      requote();
    });
  }

  function optionCarDeselect() {
    for (let index = 0; index < vm.qt.options.length; index++) {
      const element = vm.qt.options[index];
      element.selected = false;
    }
  }

  function requiredSelectVehicle(res = null) {
    let option = res.options;
    let required = true;
    vm.isRequiredSelectVehicle = false;
    if (res) {
      if (option.allTransfers) {
        required = false;
      } else if (option.searchedTransfer) {
        required = false;
      }
    }
    /**if(total <= vm.car.maxPassengers || getAllAvailableCars){
            required = false;
        }**/
    vm.isRequiredSelectVehicle = required;
  }
  function showAlertInit() {
    var item = vm.data && vm.data.trip ? vm.data.trip : null;
    //var search_to = vm.data && vm.data.search_to ? vm.data.search_to : null;
    showAlert(item, false, true); // rountrip =  false
    //showAlert(search_to, 'to');
  }
  function showAlert(item, round_trip, reverse = false) {
    var property = "pickup";
    var property_round = "dropoff";

    if (!item) {
      vm.msn[property].display = "none";
      vm.msn[property].msn = "";
      vm.msn[property_round].display = "none";
      vm.msn[property_round].msn = "";
      return;
    }
    var destination = item.pickupType;
    var destination_to;
    var search_to = item && item.dropoffType ? item : null;
    if (search_to) {
      destination_to = search_to.dropoffType;
    }
    if (destination_to && destination == "airport") {
      vm.msn[property].display = "block";
      vm.msn[property].msn = vm.ln["msn_searchbox_date_" + property];
    } else if (
      destination_to &&
      destination == "address" &&
      destination_to == "airport"
    ) {
      vm.msn[property].display = "block";
      vm.msn[property].msn = vm.ln["msn_searchbox_date_dropoff"];
    } else {
      vm.msn[property].display = "block";
      vm.msn[property].msn = vm.ln["msn_searchbox_pickuptime"];
    }

    if (!round_trip) {
      if (destination && destination_to == "airport") {
        vm.msn[property_round].display = "block";
        vm.msn[property_round].msn = vm.ln["msn_searchbox_date_pickup"];
      } else if (
        destination &&
        destination_to == "address" &&
        destination == "airport"
      ) {
        vm.msn[property_round].display = "block";
        vm.msn[property_round].msn = vm.ln["msn_searchbox_date_dropoff"];
      } else {
        vm.msn[property_round].display = "block";
        vm.msn[property_round].msn = vm.ln["msn_searchbox_pickuptime"];
      }
    } else {
      vm.msn[property_round].display = "block";
      vm.msn[property_round].msn = vm.ln["msn_searchbox_pickuptime"];
    }
  }
  function getMessagePicker(type) {
    $scope.$apply(() => {
      let destination;
      if (type) {
        if (type == "pickup") {
          destination = vm.data.trip.pickupType;
        } else {
          destination = vm.data.trip.dropoffType;
        }
      }
      vm.msn.selected = destination ?? "default";
    });
    let documents = document.querySelectorAll(
      ".daterangepicker.ltr.single.opensright.show-calendar .calendar-time"
    );
    document
      .querySelectorAll(
        ".daterangepicker.ltr.single.opensright.show-calendar .messagePicker"
      )
      .forEach((res) => {
        res.remove();
      });
    documents.forEach((doc) => {
      doc.insertAdjacentHTML(
        "beforebegin",
        `<div class="messagePicker">${vm.msn.messages[vm.msn.selected] ||
          ""}</div>`
      );
    });
  }

  function showTooltip(type, record) {
    var is_address = record.type || getTypeGM(record);

    if (is_address == "address") {
      $("#" + type + "_view_edit_tooltip").tooltip("show");

      setTimeout(function() {
        $("#" + type + "_view_edit_tooltip").tooltip("hide");
      }, 6000);
    }
  }

  function validConfirmEmail() {
    var email_customer = (vm.data.customerEmail || "").toLowerCase();
    var email_customer_confirm = (vm.data.confirm_email || "").toLowerCase();
    return email_customer == email_customer_confirm;
  }

  function getLastComment(comt) {
    vm.allComments = comt.split(delimiter);
    last_comment = vm.allComments[vm.allComments.length - 1];
    return last_comment;
  }

  function setComment(comment) {
    if (comment) {
      vm.allComments.push(comment);
    }
    return vm.allComments.join(delimiter);
  }

  /****
   *    End Code
   ****/
  vm.agency_data = {};
  vm.sendEmailVoucher = function(reservation) {
    vm.agency_data = {};
    $("#c-modal-email-change").modal("show");
    vm.agency_data.id =
      reservation.booking_id ||
      reservation.bookingReference ||
      reservation.id ||
      reservation.Id;
    vm.agency_data.email =
      reservation.email || reservation.customerEmail || vm._s.email;
    vm.agency_data.lang = window.__mt.ln.lang;
  };
  vm.onSubmitEmailVoucher = function(form) {
    vm.agency_data.submit = true;
    if (form.$valid) {
      vm.loading = true;
      $http
        .post(window.__mt.setting.api_voucher_emal, vm.agency_data)
        .then(onResetEmailVoucher, getBookingError);
    }
  };

    vm.downloadVoucher =  () => {
        vm.loading = true;

        $http({
            method: 'GET',
            url: window.__mt.setting.url_voucher_download,
            params: vm.agency_data,
            responseType: 'blob',
            timeout: 120000
        }).then(function(response) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = vm.agency_data.id + ".pdf";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();

            vm.loading = false;
            $("#c-modal-email-change").modal("hide");
        }).catch(function(error) {
            console.error('Error downloading PDF:', error);
            vm.loading = false;
            alert('Error generating PDF. Please try again.');
        });
    }

  function onResetEmailVoucher(data) {
    var response = data.data;
    vm.loading = false;
    if (response.code == 200) {
      vm.agency_data = {};
      $("#c-modal-email-change").modal("hide");
    } else {
      getBookingError(response);
    }
  }

    function redirectVoucher(){
        vm.loading = true;       
        $http.get(window.__mt.setting.url_voucher_download,{params:vm.agency_data}).then(onRedirect,redirectError);
    }

    function onRedirect(data){     
         var response = data.data;        
        if(response.success){
            window.open(response.success,'_blank');           
        }else if(response.error){
            redirectError();
        }
        vm.loading = false;
    }

    function redirectError(){
        console.error('Error al generar el voucher');
    }

    function downloadFile(params, url) {
        const query = new URLSearchParams(params).toString();
        url = url + "?" + query;
        const a = document.createElement("a");
        a.href = url;
        a.download = params.id + ".pdf";
        a.setAttribute("target", "_blank")
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();

    }

    vm.copyToClipboard = function(text) {
        if (!text) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function() {
                showCopyFeedback();
            }).catch(function() {
                fallbackCopyToClipboard(text);
            });
        } else {
            fallbackCopyToClipboard(text);
        }
    }

    function fallbackCopyToClipboard(text) {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        textArea.style.top = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            showCopyFeedback();
        } catch (err) {
            console.error('Error al copiar:', err);
        }

        document.body.removeChild(textArea);
    }

    function showCopyFeedback() {
        $('.copy-text').hide();
        $('.copy-icon').show();
        $('.btn-close').addClass('copied');

        $timeout(function() {
            $('.copy-text').show();
            $('.copy-icon').hide();
            $('.btn-close').removeClass('copied');
        }, 3000);
    }
}
